import React from 'react';
import { MultiTradeInState, TradeIns } from '../../../types';
import PlusIcon from '../icons/PlusIcon';

export type ContentHeaderProps = {
    title: string;
    maxtradeIns: number;
    multiTradeInState: MultiTradeInState;
    isMultiTradeInsEnabled?: boolean;
    tradeInSummary?: Record<string, any>;
    addTradeIn: () => void;
};

class ContentHeader extends React.Component<ContentHeaderProps> {
    constructor(props) {
        super(props);
    }

    addTradeIn = (): void => {
        if (this.props.multiTradeInState.tradeIns.length === this.props.maxtradeIns) return;
        this.props.addTradeIn();
    };

    renderAddButton = (maxtradeIns: number, tradeIns: TradeIns[]): React.ReactNode => {
        const allTradeInsCompleted = tradeIns.every((tradeIn) => tradeIn.tradeInComponent.isCompleted === true);
        const isMultiTradeEnabled = tradeIns.length < maxtradeIns && this.props.isMultiTradeInsEnabled && allTradeInsCompleted;
        if (!isMultiTradeEnabled) return null;

        return (
            <button
                className="content-header-add-button"
                onClick={this.addTradeIn}
                aria-label="Add trade-in vehicle"
                title="Add Another Trade-In"
                data-testid="add-tradein-button"
            >
                <span className="button-icon">
                    <PlusIcon />
                </span>
                <span className="button-text">Add Another Trade-In</span>
            </button>
        );
    };

    render() {
        const { title, maxtradeIns, multiTradeInState, tradeInSummary } = this.props;
        const { tradeIns } = multiTradeInState;

        return (
            <div className="content-header">
                <div className="content-header-row">
                    <h1 className="content-header-title" data-testid="content-header-title">
                        {tradeInSummary.netTrade === 0 ? title : 'Trade-In Total Equity'}
                    </h1>
                    <div className="content-header-value" data-testid="content-header-value">
                        {tradeInSummary.netTrade !== 0
                            ? `$${tradeInSummary.netTrade.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
                            : ''}
                    </div>
                </div>
                <div className="content-header-actions">{this.renderAddButton(maxtradeIns, tradeIns)}</div>
            </div>
        );
    }
}

export default ContentHeader;
